import { ArrowRight, CaretLeft } from "@phosphor-icons/react";
import { useEDCFlow } from "@smvtech/x-flux";
import { Button, Form, Input } from "antd";
import { SyntheticEvent, useEffect } from "react";
import { usePassportStep } from "pages/SignUp/Components/SignupFormSection/Components/PassportStep/usePassportStep";
import { useNavigate } from "react-router-dom";

type Props = {
	onNext: () => void;
};

const PassportDetailScreen: React.FC<Props> = ({ onNext }) => {
	const [form] = Form.useForm<SignupFormValues>();
	const navigate = useNavigate();

	const { order } = useEDCFlow();

	const { handleSearchPassport, handleClaimApplication, isSubmitting, defaultPassport } =
		usePassportStep();

	useEffect(() => {
		if (defaultPassport) {
			form.validateFields(["passport"]);
		}
	}, [defaultPassport]);

	return (
		<div className="h-dvh overflow-y-hidden bg-white flex flex-col">
			<div className="py-[13px] border-b border-gray-200 relative flex items-center justify-center shrink-0">
				<button onClick={() => navigate(-1)} className="absolute left-4 text-gray-600">
					<CaretLeft size={20} weight="bold" />
				</button>
				<p className="text-sm font-semibold text-[#3730A3]">{order?.organisation?.name}</p>
			</div>
			<div className="flex-1 px-6 pt-10 pb-6">
				<Form form={form} layout="vertical">
					<div className="flex flex-col text-center space-y-6">
						<img
							src="https://stampmyvisa-public.s3.ap-south-1.amazonaws.com/biz-share-questionnaire/homescreen_hero.png"
							alt="Visa start"
							className="w-full max-w-xs mx-auto"
						/>

						<p className="text-base font-semibold text-gray-900">Let’s verify your passport to continue!</p>

						<div className="w-full text-left">
							<Form.Item
								name="passport"
								required
								validateTrigger="onBlur"
								rules={[
									{
										required: true,
										validator: async (_, value) => {
											if (!value) return Promise.reject(new Error("Please enter your passport number"));
											try {
												await handleSearchPassport(value);
											} catch (error: any) {
												const msg = error?.response?.data?.message || "Traveller does not exist in order";
												return Promise.reject(new Error(msg));
											}
										}
									}
								]}
								getValueFromEvent={(event: SyntheticEvent<HTMLInputElement>) => {
									event.currentTarget.value = event.currentTarget.value.toUpperCase();
									return event.currentTarget.value;
								}}>
								<Input
									placeholder="Enter your passport number"
									className="rounded-lg py-3 text-sm"
								/>
							</Form.Item>
						</div>

						<Button
							block
							type="primary"
							loading={isSubmitting}
							disabled={isSubmitting}
							onClick={async () => {
								try {
									await form.validateFields(["passport"]);
								} catch {
									return;
								}
								await handleClaimApplication();
								onNext();
							}}
							className="flex-1 flex items-center justify-center gap-2 px-4 py-1 h-11 rounded-xl text-sm font-medium transition border border-[#4E45C4] bg-gradient-to-b from-[#554FB0] to-[#332D96] text-white">
							<span className="flex items-center justify-center gap-2">
								Continue
								<ArrowRight size={18} weight="bold" />
							</span>
						</Button>

						<p className="text-xs text-gray-500">Your details are shared securely.</p>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default PassportDetailScreen;

